export const REFRESH_INTERVAL_MS = 5 * 60 * 1000; // 5 min
export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const FULL_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const adminUrl = "https://reyago.reya.net/backoffice"
export const BASE_URL = "/api";

export const utcTimeToLocal = (utcTime) => {
  if (utcTime === null || utcTime === undefined) return utcTime;

  let hours, minutes;

  if (typeof utcTime === 'number') {
    hours = Math.trunc(utcTime / 60);
    minutes = utcTime % 60;
  } else if (typeof utcTime === 'string') {
    [hours, minutes] = utcTime.split(':').map(Number);
  } else {
    return utcTime;
  }

  const d = new Date();
  d.setUTCHours(hours, minutes, 0, 0);

  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

export const localTimeToUtcString = (timeStr, referenceDate = new Date()) => {
  if (!timeStr) return timeStr;

  const [hours, minutes] = timeStr.split(':').map(Number);

  const d = new Date(referenceDate);
  d.setHours(hours, minutes, 0, 0);

  return `${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`;
};



export const encodeQueryFilter = (filter) => {
  return encodeURIComponent(JSON.stringify(filter));
};

export const formatDate = (date) => {
  return date.toISOString().split("T")[0] // "YYYY-MM-DD"
};


export const getDateRange = (filter) => {
  const today = new Date();

  if (filter === "today" || filter === "day") {
    const d = formatDate(today);
    return { start: d, end: d };
  }

  if (filter === "tomorrow") {
    const t = new Date();
    t.setDate(today.getDate() + 1);
    const d = formatDate(t);
    return { start: d, end: d };
  }

  if (filter === "week") {
    const curr = new Date();
    const first = curr.getDate() - curr.getDay() + (curr.getDay() === 0 ? -6 : 1); 
    const last = first + 6;

    const start = new Date(curr.setDate(first));
    const end = new Date(curr.setDate(last));

    return {
      start: formatDate(start),
      end: formatDate(end),
    };
  }

  return null; // "all"
};

export const getScheduledDate = (date) => {
  const base = new Date();

  if (date === 'tomorrow') base.setDate(base.getDate() + 1);
  else if (date === 'day2') base.setDate(base.getDate() + 2);
  else if (date === 'day3') base.setDate(base.getDate() + 3);

  return parseInt(
    `${base.getFullYear()}${String(base.getMonth() + 1).padStart(2, '0')}${String(base.getDate()).padStart(2, '0')}`
  );
};

export const formatLocalDate = (date) => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};
